const BASE = process.env.REACT_APP_API_URL || "";

export async function api(path, options = {}) {
  const token = localStorage.getItem("sensoria_token");

  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers,
  });

  const data = await res.json();

  if (!res.ok) {
    const err = new Error(data.error || data.detail || "Erreur serveur");
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}
